import { useQuery } from 'react-query';
import { BrandingPackageQueryService } from '@wealthlane/api-services/wealthlane-identity-service';

export function useGetBrandingConfig(options: { enabled: boolean }) {
  return useQuery(
    ['getCurrentCompanyBrandingConfig'],
    async () => {
      return await BrandingPackageQueryService
        .getApiIdentityApiAppBrandingPackageQueryCurrentCompanyBrandingPackageConfig();
    },
    {
      enabled: options.enabled,
      retry: false,
      keepPreviousData: true,
    }
  );
}
